/**
 * Input limits shared by the Lab Profile page and Lab Onboarding, so both forms accept
 * exactly the same data.
 *
 * The "About the Lab" limit matches the doctor bio limit (500) and keeps the text readable
 * in the patient app's lab card and profile.
 */
export const BIO_MAX_LENGTH = 500;
